export const CONFIRM_DIALOG_I18N = {
  button: {
    no: $localize`:@@shared.confirmDialog.button.no:いいえ`,
    yes: $localize`:@@shared.confirmDialog.button.yes:はい`,
  },
} as const;
